import { useState, useRef, useLayoutEffect, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../ThemeProvider";
import { NavigationRefreshProvider } from "../../context/NavigationRefreshContext";
import PhoneReviewPendingModal from "../PhoneReviewPendingModal";
import BarraSubidaGlobal, { CaptacionUploadBootstrap } from "../captaciones/BarraSubidaGlobal";
import usePermiso from "../../hooks/usePermiso";
import ModalNuevoTicket from "../ModalNuevoTicket";
import ModalComunicacionInterna from "../ModalComunicacionInterna";
import PopupMensajeInterno from "../PopupMensajeInterno";
import api from "../../services/api";
import { captacionApiBase } from "../../services/captacionUpload";

const MENU_ITEMS = [
  // nodeId: "admin_felipe" ya tiene restrictedTo: ["admin"] en el catálogo,
  // así que sigue oculto para el resto de roles igual que con el adminOnly anterior.
  { label: "⚡ Felipe", ruta: "/admin/felipe", nodeId: "admin_felipe" },
  { label: "🎫 Tickets de soporte", ruta: "/soporte/tickets", nodeId: "soporte_tickets_menu" },
  { label: "📡 Monitor", ruta: "/monitor", nodeId: "monitor" },
  { label: "⚖️ Carla", ruta: "/carla", nodeId: "carla" },
  { label: "📞 Números Telnyx", ruta: "/numeros-telnyx", nodeId: "numeros_telnyx" },
  { label: "🤖 Marco", ruta: "/configuracion/marco", nodeId: "marco" },
  { label: "🏘️ Promociones", ruta: "/promociones", nodeId: "promociones" },
  // "Clientes" ya no es un enlace propio del menú ☰: el acceso es siempre a
  // través de "CONTACTOS" en la cabecera, que ya incluye Clientes/Propietarios/
  // Otros contactos como pestañas. El permiso ct_clientes sigue aplicando ahí.
  { label: "Demandas", ruta: "/demandas", nodeId: "demandas" },
  { label: "Reportes", ruta: "/reportes", nodeId: "reportes" },
  { label: "🕷️ MarketPlace", ruta: "/scraping-portales", nodeId: "scraping" },
  { label: "📋 Comparar Pisos v2", ruta: "/comparar-pisos-v2", nodeId: "comparar" },
  { label: "📋 Comparar Idealista v2", ruta: "/comparar-idealista-v2", nodeId: "comparar" },
  { label: "📋 Comparar Habitaclia v2", ruta: "/comparar-habitaclia-v2", nodeId: "comparar" },
  { label: "📋 Comparar Fotocasa v2", ruta: "/comparar-fotocasa-v2", nodeId: "comparar" },
  { label: "🖨️ Plantillas", ruta: null, nodeId: "plantillas", submenu: [
    { label: "Plantillas de impresión", ruta: "/plantillas/impresion", nodeId: "pla_impresion" },
    { label: "Documentación", ruta: "/plantillas/documentacion", nodeId: "pla_documentacion" },
    { label: "WhatsApp", ruta: "/plantillas/whatsapp", nodeId: "pla_whatsapp" },
  ]},
  { label: "Configuracion", ruta: null, nodeId: "configuracion", submenu: [
    { label: "🪟 Escaparate", ruta: "/configuracion/escaparate", nodeId: "cfg_escaparate" },
    { label: "🤖 Marco", ruta: "/configuracion/marco", nodeId: "cfg_marco" },
    { label: "👤 Agentes", ruta: "/configuracion?tabla=agentes", nodeId: "cfg_agentes" },
    { label: "🤖 Ana Inputs", ruta: "/ana-config", nodeId: "cfg_ana" },
    { label: "📱 Campos App Móvil", ruta: "/config-campos-movil", nodeId: "cfg_campos_movil" },
    { label: "💬 Conexión WhatsApp", ruta: "/configuracion/whatsapp", nodeId: "cfg_whatsapp" },
    { label: "📧 Mi correo", ruta: "/configuracion/correo", nodeId: "cfg_correo" },
    { label: "📋 Obligatorios propiedad", ruta: "/configuracion/campos-obligatorios", nodeId: "campos_obligatorios" },
    { label: "🔑 Usuarios", ruta: "/configuracion/usuarios", nodeId: "cfg_usuarios" },
    { label: "🔐 Permisos y roles", ruta: "/configuracion/permisos", nodeId: "usuarios_roles" },
    { label: "🌐 Portales Inmobiliarios", ruta: "/configuracion/portales", nodeId: "cfg_portales" },
    { label: "🕷️ Scraping", ruta: "/configuracion/scraping", nodeId: "cfg_scraping_config" },
    { label: "Tablas Auxiliares", ruta: null, nodeId: "tablas_auxiliares", submenu: [
      { label: "Tipo inmueble", slug: "tipo-inmueble", nodeId: "cfg_ta_tipo_inmueble" },
      { label: "Procedencias", slug: "procedencias", nodeId: "cfg_ta_procedencias" },
      { label: "Cocina", slug: "cocina", nodeId: "cfg_ta_cocina" },
      { label: "Vistas", slug: "vistas", nodeId: "cfg_ta_vistas" },
      { label: "Calefaccion", slug: "calefaccion", nodeId: "cfg_ta_calefaccion" },
      { label: "Orientacion", slug: "orientacion", nodeId: "cfg_ta_orientacion" },
      { label: "Aire acondicionado", slug: "aire-acondicionado", nodeId: "cfg_ta_aire" },
      { label: "Muebles", slug: "muebles", nodeId: "cfg_ta_muebles" },
      { label: "Piscina", slug: "piscina", nodeId: "cfg_ta_piscina" },
      { label: "Estado inmueble", slug: "estado-inmueble", nodeId: "cfg_ta_estado_inmueble" },
      { label: "Suelos", slug: "suelos", nodeId: "cfg_ta_suelos" },
      { label: "Carpintería interior", slug: "carpinteria-interior", nodeId: "cfg_ta_carp_int" },
      { label: "Carpintería exterior", slug: "carpinteria-exterior", nodeId: "cfg_ta_carp_ext" },
      { label: "Tipo terreno", slug: "tipo-terreno", nodeId: "cfg_ta_tipo_terreno" },
      { label: "Zona", slug: "zona", nodeId: "cfg_ta_zona" },
      { label: "Urbanizaciones", slug: "urbanizacion", nodeId: "cfg_ta_urbanizacion" },
    ]},
  ]},
];

/**
 * El "ver" del padre manda: si Configuración o Plantillas está apagado,
 * se oculta todo el bloque (aunque algún hijo siga en true).
 * Si el padre está encendido, cada hijo se filtra por su propio "ver".
 * Una carpeta sin ruta y sin hijos visibles también se oculta.
 */
function itemMenuVisible(item, puede, usuario) {
  if (item.adminOnly && usuario?.rol !== "admin") return false;
  const selfOk = !item.nodeId || puede(item.nodeId, "ver");
  if (!selfOk) return false;
  if (item.submenu?.length) {
    const anyChild = item.submenu.some((sub) => itemMenuVisible(sub, puede, usuario));
    if (anyChild) return true;
    return Boolean(item.ruta);
  }
  return true;
}

const BREADCRUMB_MAP = {
  "/dashboard": "Dashboard",
  "/propiedades": "Propiedades",
  "/propiedades/nueva": "Alta",
  "/pipeline": "Pipeline",
  "/tareas": "Tareas",
  "/clientes": "Clientes",
  "/contactos": "Contactos",
  "/demandas": "Demandas",
  "/configuracion": "Configuracion",
  "/configuracion/portales": "Portales",
  "/agenda": "Agenda",
  "/buscador": "Buscador",
  "/gestion-ventas": "Gestión ventas",
  "/carla": "Carla",
  "/numeros-telnyx": "Números Telnyx",
  "/admin/felipe": "Felipe",
  "/soporte/tickets": "Tickets de soporte",
  "/reportes": "Reportes",
  "/monitor": "Monitor",
  "/scraping-portales": "MarketPlace",
  "/pruebas": "Pruebas",
  "/comparar-pisos-v2": "Comparar Pisos v2",
  "/comparar-idealista-v2": "Comparar Idealista v2",
  "/comparar-habitaclia-v2": "Comparar Habitaclia v2",
  "/comparar-fotocasa-v2": "Comparar Fotocasa v2",
  "/matching": "Matching",
  "/plantillas": "Plantillas",
  "/plantillas/impresion": "Plantillas de impresión",
  "/plantillas/documentacion": "Documentación",
  "/plantillas/whatsapp": "WhatsApp",
  "/configuracion/permisos": "Permisos y roles",
  "/configuracion/marco": "Marco",
  "/configuracion/video-marco": "Marco",
  "/promociones": "Promociones",
  "/promociones/nueva": "Nueva promoción",
  "/configuracion/correo": "Mi correo",
};

function getBreadcrumbs(pathname) {
  if (pathname === "/leads" || pathname.startsWith("/leads/")) {
    return [{ label: "Dashboard", ruta: "/dashboard" }, { label: "Pipeline", ruta: "/pipeline" }];
  }
  if (pathname.startsWith("/promociones/") && pathname !== "/promociones/nueva") {
    const ref = decodeURIComponent(pathname.slice("/promociones/".length).split("/")[0] || "");
    return [
      { label: "Dashboard", ruta: "/dashboard" },
      { label: "Promociones", ruta: "/promociones" },
      { label: ref || "Promoción", ruta: pathname },
    ];
  }
  var parts = pathname.split("/").filter(Boolean);
  var crumbs = [{ label: "Dashboard", ruta: "/dashboard" }];
  if (pathname === "/dashboard") return crumbs;
  var acumulado = "";
  for (var i = 0; i < parts.length; i++) {
    acumulado += "/" + parts[i];
    var label = BREADCRUMB_MAP[acumulado];
    if (!label) {
      var prev = parts[i - 1];
      if (prev === "propiedades") label = "Detalle";
      else if (prev === "leads" || prev === "clientes" || prev === "contactos") continue;
      else if (prev === "demandas") label = "Detalle";
      else label = parts[i];
    }
    crumbs.push({ label: label, ruta: acumulado });
  }
  return crumbs;
}

export default function AppLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { usuario, logout, refrescarUsuario } = useAuth();
  const { puede } = usePermiso();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme.name === "dark";
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [subMenuAbierto, setSubMenuAbierto] = useState(null);
  const [subMenuAbierto2, setSubMenuAbierto2] = useState(null);
  const [ticketAbierto, setTicketAbierto] = useState(false);
  const [comInternaAbierta, setComInternaAbierta] = useState(false);
  const [comInternaNoLeidos, setComInternaNoLeidos] = useState(0);
  const [comInternaPopup, setComInternaPopup] = useState(null); // { mensaje, esRecordatorio }
  const [comInternaReplyTo, setComInternaReplyTo] = useState(null);
  const comInternaRecTimersRef = useRef([]);
  const comInternaRecVistosRef = useRef(new Set());
  const comInternaMsgVistosRef = useRef(new Set());
  const comInternaLastMsgIdRef = useRef(0);
  const comInternaBcRef = useRef(null);
  const menuNavRef = useRef(null);
  const headerRef = useRef(null);
  const [headerH, setHeaderH] = useState(52);

  const mostrarMensajeInternoPopup = (msg, { esRecordatorio = false, desdeBroadcast = false } = {}) => {
    if (!msg?.id) return;
    if (comInternaMsgVistosRef.current.has(msg.id)) return;
    comInternaMsgVistosRef.current.add(msg.id);
    if (msg.id > comInternaLastMsgIdRef.current) comInternaLastMsgIdRef.current = msg.id;
    setComInternaPopup({ mensaje: msg, esRecordatorio: !!esRecordatorio });
    if (!esRecordatorio) setComInternaNoLeidos((n) => Math.max(n, 1));
    // Ampliar: si esta pestaña lo recibe por SSE/poll, avisa a las demás.
    if (!desdeBroadcast && comInternaBcRef.current) {
      try {
        comInternaBcRef.current.postMessage({
          type: esRecordatorio ? "recordatorio" : "mensaje_nuevo",
          mensaje: msg,
        });
      } catch {
        /* BroadcastChannel no disponible */
      }
    }
  };

  const mostrarRecordatorioInterno = (payload, opts = {}) => {
    const msg = payload?.mensaje;
    const rid = payload?.recordatorio_id;
    if (!msg?.id) return;
    if (rid != null) {
      if (comInternaRecVistosRef.current.has(rid)) return;
      comInternaRecVistosRef.current.add(rid);
    }
    mostrarMensajeInternoPopup(msg, { esRecordatorio: true, ...opts });
  };

  /** Temporizador local de respaldo (misma pestaña) por si el SSE falla. */
  const programarRecordatorioLocal = (rec) => {
    if (!rec?.recordatorio_id || !rec?.recordar_en || !rec?.mensaje) return;
    const delay = new Date(rec.recordar_en).getTime() - Date.now() + 250;
    if (!Number.isFinite(delay)) return;
    const t = window.setTimeout(() => {
      mostrarRecordatorioInterno(rec);
      // Marca en servidor (poll de vencidos) para no reabrir en otra pestaña en bucle.
      api.get("/mensajes-internos/recordatorios/vencidos").catch(() => {});
    }, Math.max(0, Math.min(delay, 2147483647)));
    comInternaRecTimersRef.current.push(t);
  };

  const refrescarNoLeidosComInterna = async () => {
    try {
      const { data } = await api.get("/mensajes-internos/no-leidos");
      setComInternaNoLeidos(data?.total || 0);
    } catch {
      /* silencioso */
    }
  };

  /** Al cerrar el popup: marcar leído y quitar/actualizar el badge del 💬. */
  const cerrarPopupMensajeInterno = async () => {
    const msg = comInternaPopup?.mensaje;
    setComInternaPopup(null);
    if (msg?.id && !comInternaPopup?.esRecordatorio) {
      try {
        await api.patch(`/mensajes-internos/${msg.id}/leido`);
      } catch {
        /* ok: igual refrescamos el contador */
      }
    }
    await refrescarNoLeidosComInterna();
  };

  useEffect(() => {
    if (!puede("comunicacion_interna", "ver")) {
      setComInternaNoLeidos(0);
      return undefined;
    }
    let cancelled = false;
    const cargar = async () => {
      try {
        const { data } = await api.get("/mensajes-internos/no-leidos");
        if (!cancelled) setComInternaNoLeidos(data?.total || 0);
      } catch {
        /* silencioso: no bloquear cabecera */
      }
    };
    cargar();
    // Ampliar: poll de respaldo si el SSE se cae (Railway / pestaña en segundo plano).
    const id = setInterval(cargar, 60000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [puede, usuario?.id]);

  // SSE + BroadcastChannel (sync pestañas) + poll inbox (si un stream muere).
  useEffect(() => {
    if (!puede("comunicacion_interna", "ver") || !usuario?.id) return undefined;
    const token = localStorage.getItem("token");
    if (!token) return undefined;

    let closed = false;
    let es = null;
    let retryTimer = null;
    let retryMs = 1500;
    let sseOk = false;

    let bc = null;
    try {
      bc = new BroadcastChannel("vc-mensajes-internos");
      comInternaBcRef.current = bc;
      bc.onmessage = (ev) => {
        const data = ev?.data;
        if (!data?.mensaje) return;
        if (data.type === "recordatorio") {
          mostrarRecordatorioInterno({ mensaje: data.mensaje, recordatorio_id: data.recordatorio_id }, { desdeBroadcast: true });
        } else if (data.type === "mensaje_nuevo") {
          mostrarMensajeInternoPopup(data.mensaje, { desdeBroadcast: true });
        }
      };
    } catch {
      bc = null;
      comInternaBcRef.current = null;
    }

    const cerrarEs = () => {
      if (!es) return;
      try {
        es.removeEventListener("mensaje_nuevo", onMensaje);
        es.removeEventListener("recordatorio", onRecordatorio);
        es.close();
      } catch {
        /* ignore */
      }
      es = null;
      sseOk = false;
    };

    const onMensaje = (e) => {
      try {
        const data = JSON.parse(e.data);
        mostrarMensajeInternoPopup(data?.mensaje);
      } catch {
        /* ignore */
      }
    };
    const onRecordatorio = (e) => {
      try {
        mostrarRecordatorioInterno(JSON.parse(e.data));
      } catch {
        /* ignore */
      }
    };

    const conectar = () => {
      if (closed) return;
      cerrarEs();
      const url = `${captacionApiBase()}/mensajes-internos/stream?token=${encodeURIComponent(token)}`;
      es = new EventSource(url);
      es.addEventListener("mensaje_nuevo", onMensaje);
      es.addEventListener("recordatorio", onRecordatorio);
      es.addEventListener("connected", () => {
        retryMs = 1500;
        sseOk = true;
      });
      es.onerror = () => {
        sseOk = false;
        cerrarEs();
        if (closed) return;
        if (retryTimer) clearTimeout(retryTimer);
        retryTimer = window.setTimeout(() => {
          retryMs = Math.min(retryMs * 1.6, 15000);
          conectar();
        }, retryMs);
      };
    };

    const pollInboxYRecordatorios = async () => {
      if (closed || document.visibilityState === "hidden") return;
      try {
        const { data } = await api.get("/mensajes-internos/inbox-nuevos", {
          params: { after_id: comInternaLastMsgIdRef.current || 0 },
        });
        const lista = data?.data || [];
        // Primer arranque (after_id=0): anclar ids viejos; popup solo si es muy reciente
        // (SSE muerto justo al cargar / pestaña en background).
        if (!comInternaLastMsgIdRef.current && lista.length) {
          const maxId = Math.max(...lista.map((m) => Number(m.id) || 0));
          comInternaLastMsgIdRef.current = maxId;
          const ahora = Date.now();
          let mostrado = false;
          for (const m of lista) {
            const created = new Date(m.created_at).getTime();
            const reciente = Number.isFinite(created) && ahora - created < 120000;
            if (reciente && !mostrado && !comInternaMsgVistosRef.current.has(m.id)) {
              mostrarMensajeInternoPopup(m);
              mostrado = true;
            } else {
              comInternaMsgVistosRef.current.add(m.id);
            }
          }
        } else {
          for (const m of lista) {
            if (!comInternaMsgVistosRef.current.has(m.id)) {
              mostrarMensajeInternoPopup(m);
              break; // un popup a la vez
            }
          }
        }
        const { data: dataN } = await api.get("/mensajes-internos/no-leidos");
        setComInternaNoLeidos(dataN?.total || 0);
      } catch {
        /* silencioso */
      }
      try {
        const { data } = await api.get("/mensajes-internos/recordatorios/vencidos");
        const lista = data?.data || [];
        if (lista.length) mostrarRecordatorioInterno(lista[0]);
      } catch {
        /* silencioso */
      }
    };

    conectar();
    // Anclar after_id sin popup, luego poll periódico.
    pollInboxYRecordatorios();
    const pollId = window.setInterval(pollInboxYRecordatorios, 12000);

    const onVis = () => {
      if (document.visibilityState !== "visible") return;
      // Pestaña al frente: rehacer SSE si estaba muerto + pillar mensajes perdidos.
      if (!sseOk) {
        retryMs = 1000;
        if (retryTimer) clearTimeout(retryTimer);
        conectar();
      }
      pollInboxYRecordatorios();
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      closed = true;
      document.removeEventListener("visibilitychange", onVis);
      clearInterval(pollId);
      if (retryTimer) clearTimeout(retryTimer);
      comInternaRecTimersRef.current.forEach((t) => clearTimeout(t));
      comInternaRecTimersRef.current = [];
      cerrarEs();
      try {
        bc?.close();
      } catch {
        /* ignore */
      }
      comInternaBcRef.current = null;
    };
  }, [puede, usuario?.id]);

  useLayoutEffect(() => {
    const el = headerRef.current;
    if (!el) return undefined;
    const update = () => {
      const h = Math.round(el.getBoundingClientRect().height);
      if (h > 0) setHeaderH(h);
    };
    update();
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(update) : null;
    ro?.observe(el);
    window.addEventListener("resize", update);
    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  useLayoutEffect(() => {
    const nav = menuNavRef.current;
    if (!nav || !subMenuAbierto) return;
    const el = nav.querySelector(`[data-submenu-panel="${CSS.escape(subMenuAbierto)}"]`);
    if (el) el.scrollIntoView({ block: "start", behavior: "smooth" });
  }, [subMenuAbierto]);

  useLayoutEffect(() => {
    const nav = menuNavRef.current;
    if (!nav || !subMenuAbierto2) return;
    const el = nav.querySelector(`[data-submenu-third="${CSS.escape(subMenuAbierto2)}"]`);
    if (el) el.scrollIntoView({ block: "start", behavior: "smooth" });
  }, [subMenuAbierto2]);

  // Presencia CRM: mantiene WhatsApp del agente despierto si hay alguien delante.
  useEffect(() => {
    if (!usuario?.id) return undefined;
    let stopped = false;
    const ping = () => {
      if (stopped) return;
      if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
      api.get("/presence/ping").catch(() => {});
    };
    ping();
    const timer = setInterval(ping, 60_000);
    const onVis = () => {
      if (document.visibilityState === "visible") ping();
    };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", ping);
    return () => {
      stopped = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", ping);
    };
  }, [usuario?.id]);

  const breadcrumbs = getBreadcrumbs(location.pathname);

  const cerrarMenu = () => {
    setMenuAbierto(false);
    setSubMenuAbierto(null);
    setSubMenuAbierto2(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const handleMenuItem = (item) => {
    if (item.submenu) {
      setSubMenuAbierto(subMenuAbierto === item.label ? null : item.label);
      return;
    }
    if (item.ruta) {
      navigate(item.ruta);
      cerrarMenu();
    }
  };

  // Colores del header según tema
  const headerBg = isDark ? "#08090d" : "#dce3ed";
  const headerText = isDark ? "#e2e8f0" : "#0f172a";
  const headerMuted = isDark ? "#94a3b8" : "#334155";
  const headerBorder = isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.08)";
  const headerBtnBorder = isDark ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.15)";
  const headerBtnHover = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)";

  return (
    <div className="min-h-screen" style={{ background: theme.colors.bgApp }}>
      <PhoneReviewPendingModal usuario={usuario} />
      <header ref={headerRef} className="px-6 py-2 flex items-center justify-between sticky top-0 z-50"
        style={{ background: headerBg, borderBottom: `1px solid ${headerBorder}`, transition: "background 0.3s, border-color 0.3s" }}>

        {/* Logo + Breadcrumbs */}
        <div className="flex items-center gap-4">
          <img src="/logo-vitalcasa.png" alt="Vitalcasa" style={{ height: 28, objectFit: "contain", cursor: "pointer" }} onClick={() => navigate("/dashboard")} />
          <div style={{ width: 1, height: 24, background: headerBorder, margin: "0 4px" }} />
          <div className="flex items-center gap-2 text-sm">
            {breadcrumbs.map((crumb, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span style={{ color: headerMuted }}>/</span>}
                {i < breadcrumbs.length - 1 ? (
                  <button onClick={() => navigate(crumb.ruta)} className="transition-colors" style={{ color: headerMuted, background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: "inherit" }}>{crumb.label}</button>
                ) : (
                  <span className="font-semibold" style={{ color: headerText }}>{crumb.label}</span>
                )}
              </span>
            ))}
          </div>
        </div>

        {/* Navegación central */}
        <nav className="flex items-center gap-1" style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          {[
            { label: "TAREAS", ruta: "/tareas", nodeId: "tareas" },
            { label: "PIPELINE", ruta: "/pipeline", nodeId: "pipeline" },
            { label: "CONTACTOS", ruta: "/contactos", nodeId: "contactos" },
            { label: "PROPIEDADES", ruta: "/propiedades", nodeId: "propiedades" },
            { label: "AGENDA", ruta: "/agenda", nodeId: "agenda" },
            { label: "BUSCADOR", ruta: "/buscador", nodeId: "buscador" },
            { label: "ANA", ruta: "/ana", nodeId: "ana" },
            { label: "GESTION VENTAS", ruta: "/gestion-ventas", nodeId: "gestion_ventas" },
            { label: "PRUEBAS", ruta: "/pruebas", nodeId: "pruebas" },
          ].filter(item => !item.nodeId || puede(item.nodeId, "ver")).map(item => {
            const activo = location.pathname.startsWith(item.ruta);
            return (
              <button key={item.label} onClick={() => navigate(item.ruta, { state: { navRefresh: Date.now() } })}
                style={{
                  padding: "5px 11px", borderRadius: 6, fontSize: 12, fontWeight: 700,
                  letterSpacing: "0.04em", border: "none", fontFamily: "inherit",
                  background: activo ? (isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)") : "transparent",
                  color: activo ? headerText : headerMuted,
                  cursor: "pointer", transition: "all 0.15s",
                }}
                onMouseEnter={e => { if (!activo) e.currentTarget.style.color = headerText; e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)"; }}
                onMouseLeave={e => { if (!activo) e.currentTarget.style.color = headerMuted; e.currentTarget.style.background = activo ? (isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)") : "transparent"; }}
              >{item.label}</button>
            );
          })}
        </nav>

        {/* Lado derecho */}
        <div className="flex items-center gap-3">
          <div className="text-right hidden md:block">
            <p className="text-sm font-medium" style={{ color: headerText, margin: 0 }}>{usuario?.nombre}</p>
            <p className="text-xs capitalize" style={{ color: headerMuted, margin: 0 }}>{usuario?.rol}</p>
          </div>

          <button onClick={toggleTheme}
            title={isDark ? "Modo claro" : "Modo oscuro"}
            className="flex items-center justify-center transition-colors"
            style={{ width: 34, height: 34, borderRadius: 8, border: `1px solid ${headerBtnBorder}`, background: "transparent", cursor: "pointer", fontSize: 16, color: headerText }}
            onMouseEnter={e => { e.currentTarget.style.background = headerBtnHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
            {isDark ? "☀️" : "🌙"}
          </button>

          <button onClick={handleLogout}
            className="text-xs transition-colors"
            style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${headerBtnBorder}`, background: "transparent", color: headerMuted, cursor: "pointer", fontFamily: "inherit" }}
            onMouseEnter={e => { e.currentTarget.style.color = headerText; e.currentTarget.style.borderColor = headerMuted; }}
            onMouseLeave={e => { e.currentTarget.style.color = headerMuted; e.currentTarget.style.borderColor = headerBtnBorder; }}>
            Salir
          </button>

          {puede("comunicacion_interna", "ver") && (
            <button onClick={() => setComInternaAbierta(true)}
              title={comInternaNoLeidos > 0 ? `Comunicación interna (${comInternaNoLeidos} sin leer)` : "Comunicación interna"}
              className="flex items-center justify-center transition-colors"
              style={{ position: "relative", width: 34, height: 34, borderRadius: 8, border: `1px solid ${headerBtnBorder}`, background: "transparent", cursor: "pointer", fontSize: 16, color: headerText }}
              onMouseEnter={e => { e.currentTarget.style.background = headerBtnHover; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
              💬
              {comInternaNoLeidos > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    minWidth: 16,
                    height: 16,
                    padding: "0 4px",
                    borderRadius: 999,
                    background: "#0d9488",
                    color: "#fff",
                    fontSize: 10,
                    fontWeight: 800,
                    lineHeight: "16px",
                    textAlign: "center",
                    boxShadow: "0 0 0 2px " + (isDark ? "#0f172a" : "#ffffff"),
                  }}
                >
                  {comInternaNoLeidos > 99 ? "99+" : comInternaNoLeidos}
                </span>
              )}
            </button>
          )}

          {puede("soporte_crear_ticket", "ver") && (
            <button onClick={() => setTicketAbierto(true)}
              title="Ticket de soporte"
              className="flex items-center justify-center transition-colors"
              style={{ width: 34, height: 34, borderRadius: 8, border: `1px solid ${headerBtnBorder}`, background: "transparent", cursor: "pointer", fontSize: 16, color: headerText }}
              onMouseEnter={e => { e.currentTarget.style.background = headerBtnHover; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
              🎫
            </button>
          )}

          <button onClick={() => {
            if (menuAbierto) {
              cerrarMenu();
              return;
            }
            // Al abrir el ☰ recarga permisos: si el admin acaba de activar
            // Monitor / WhatsApp a Josefa, lo ve sin F5 ni esperar 5 minutos.
            refrescarUsuario?.();
            setMenuAbierto(true);
          }}
            className="transition-colors"
            style={{ padding: 6, borderRadius: 8, background: "transparent", border: "none", cursor: "pointer" }}
            onMouseEnter={e => { e.currentTarget.style.background = headerBtnHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={headerMuted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </div>
      </header>

      {menuAbierto && (
        <>
          <div className="fixed inset-0 z-30" style={{ backgroundColor: "transparent" }} onClick={cerrarMenu}></div>
          <div
            className="fixed right-0 w-[min(100vw,20rem)] sm:w-80 shadow-2xl z-40"
            style={{
              top: headerH,
              height: `calc(100% - ${headerH}px)`,
              background: theme.colors.bgPanel,
              borderLeft: `1px solid ${theme.colors.border}`,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6 flex items-center justify-between" style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
              <h2 className="font-bold" style={{ color: theme.colors.textPrimary }}>Menu</h2>
              <button onClick={cerrarMenu} className="text-xl font-bold" style={{ color: theme.colors.textMuted, background: "none", border: "none", cursor: "pointer" }}>✕</button>
            </div>
            <nav ref={menuNavRef} className="p-4 overflow-y-auto overflow-x-hidden" style={{ maxHeight: "calc(100% - 73px)", scrollBehavior: "auto" }}>
              <div className="flex flex-col gap-1">
                {MENU_ITEMS.filter(item => itemMenuVisible(item, puede, usuario)).map(item => (
                  <div key={item.label}>
                    <button onClick={() => handleMenuItem(item)} className="w-full text-left px-4 py-3 rounded-lg text-sm font-medium flex items-center justify-between transition-colors"
                      style={{ color: theme.colors.textSecondary, background: "transparent", border: "none", cursor: "pointer", fontFamily: "inherit" }}
                      onMouseEnter={e => { e.currentTarget.style.background = theme.colors.bgCardHover; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
                      {item.label}
                      {item.submenu && (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={"transition-transform " + (subMenuAbierto === item.label ? "rotate-90" : "")}>
                          <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                      )}
                    </button>
                    {item.submenu && subMenuAbierto === item.label && (
                      <div className="ml-4 flex flex-col gap-1 mt-1" data-submenu-panel={item.label}>
                        {item.submenu.filter(sub => itemMenuVisible(sub, puede, usuario)).map(sub => (
                          <div key={sub.label}>
                            {sub.submenu ? (
                              <>
                                <button type="button" title={sub.label} onClick={() => setSubMenuAbierto2(subMenuAbierto2 === sub.label ? null : sub.label)} className="w-full text-left px-4 py-2 rounded-lg text-sm flex items-center justify-between gap-2 min-w-0"
                                  style={{ color: theme.colors.textMuted, background: "transparent", border: "none", cursor: "pointer", fontFamily: "inherit" }}>
                                  <span className="min-w-0 flex-1 truncate">{sub.label}</span>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={"shrink-0 transition-transform " + (subMenuAbierto2 === sub.label ? "rotate-90" : "")}>
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                  </svg>
                                </button>
                                {subMenuAbierto2 === sub.label && (
                                  <div className="ml-4 flex flex-col gap-1 mt-1" data-submenu-third={sub.label}>
                                    {(sub.label === "Tablas Auxiliares"
                                      ? [...sub.submenu].sort((a, b) => a.label.localeCompare(b.label, "es", { sensitivity: "base" }))
                                      : sub.submenu
                                    ).filter(sub2 => itemMenuVisible(sub2, puede, usuario)).map(sub2 => (
                                      <button type="button" title={sub2.label} key={sub2.label} onClick={() => { navigate("/configuracion?tabla=" + sub2.slug); cerrarMenu(); }}
                                        className="w-full min-w-0 text-left px-4 py-2 rounded-lg text-sm block truncate"
                                        style={{ color: theme.colors.textMuted, background: "transparent", border: "none", cursor: "pointer", fontFamily: "inherit" }}
                                        onMouseEnter={e => { e.currentTarget.style.background = theme.colors.accentBlueLight; e.currentTarget.style.color = theme.colors.accentBlue; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = theme.colors.textMuted; }}>
                                        {sub2.label}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </>
                            ) : (
                              <button type="button" title={sub.label} onClick={() => { navigate(sub.ruta || "/configuracion?tabla=" + sub.slug); cerrarMenu(); }}
                                className="w-full min-w-0 text-left px-4 py-2 rounded-lg text-sm block truncate"
                                style={{ color: theme.colors.textMuted, background: "transparent", border: "none", cursor: "pointer", fontFamily: "inherit" }}
                                onMouseEnter={e => { e.currentTarget.style.background = theme.colors.accentBlueLight; e.currentTarget.style.color = theme.colors.accentBlue; }}
                                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = theme.colors.textMuted; }}>
                                {sub.label}
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </nav>
          </div>
        </>
      )}

      <CaptacionUploadBootstrap />
      <NavigationRefreshProvider>{children}</NavigationRefreshProvider>
      <BarraSubidaGlobal />
      <ModalNuevoTicket open={ticketAbierto} onClose={() => setTicketAbierto(false)} />
      <ModalComunicacionInterna
        open={comInternaAbierta}
        onClose={() => {
          setComInternaAbierta(false);
          refrescarNoLeidosComInterna();
        }}
        onUnreadChange={setComInternaNoLeidos}
        replyTo={comInternaReplyTo}
        onReplyConsumed={() => setComInternaReplyTo(null)}
      />
      {comInternaPopup?.mensaje && (
        <PopupMensajeInterno
          mensaje={comInternaPopup.mensaje}
          esRecordatorio={!!comInternaPopup.esRecordatorio}
          onClose={cerrarPopupMensajeInterno}
          onRecordatorioProgramado={programarRecordatorioLocal}
          onResponder={(msg) => {
            // El popup llama onClose justo después → marca leído y limpia el badge.
            setComInternaReplyTo({ paraId: msg.de_usuario_id, nombre: msg.de_nombre });
            setComInternaAbierta(true);
          }}
        />
      )}
    </div>
  );
}